/* eslint-disable no-nested-ternary */
import React, { useState, useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { PuffLoader } from 'react-spinners';

import { uploadImage } from '../../services/uploadServices';

const MyDropzone = ({ handleChange, recommendedSize, maxSizeMB, message }) => {
  const [isPending, setIsPending] = useState(false);
  const [fileTooBig, setFileTooBig] = useState(false);

  const onDrop = useCallback(async (acceptedFiles, fileRejections) => {
    if (acceptedFiles?.length) {
      setIsPending(true);
      setFileTooBig(false);
      const uploadedImage = await uploadImage(acceptedFiles[0]);
      handleChange(uploadedImage[0]);
      setIsPending(false);
    }

    fileRejections.forEach((file) => {
      file.errors.forEach((err) => {
        if (err.code === 'file-too-large') {
          setFileTooBig(true);
        }
      });
    });
  }, []);

  const maxSize = maxSizeMB * 1000000;

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    minSize: 0,
    accept: ['image/png', 'image/jpg', 'image/jpeg'],
    maxSize,
  });

  return (
    <div {...getRootProps()} className="c-image-uploader">
      <input {...getInputProps()} />
      {isDragActive ? (
        <p>Suelta el archivo para subirlo</p>
      ) : isPending ? (
        <PuffLoader size={60} color="#E60C43" />
      ) : message ? (
        <p>{message}</p>
      ) : (
        <p>
          Arrastra o haz click para subir tu logo.
          <br />({`Recomendado ${recommendedSize}, máximo ${maxSizeMB}Mb`})
        </p>
      )}
      {fileTooBig && (
        <div className="c-image-uploader__error">
          El archivo selecccionado demasiado grande. Pruebe con otro o
          comprímalo antes de subirlo
        </div>
      )}
    </div>
  );
};

export default MyDropzone;
